import React, { useMemo, useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import TableContainer from "../../../components/Common/DataTableContainer"
import {
  downloadInvoices,
  getBookingList,
  resendInvoiceAction,
} from "../../../redux/actions/pvs"
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Label,
  Tooltip,
  UncontrolledDropdown,
} from "reactstrap"
import RefreshButton from "components/RefreshButton/RefreshButton"
import { toast } from "react-toastify"
import {
  DOWNLOAD_INVOICES_RESET,
  RESEND_INVOICE_RESET,
} from "../../../redux/types/pvs"
import {
  getAwardsCategoryList,
  getNominationList,
} from "../../../redux/actions/awards"
import ActionDropdown from "components/ActionDropdown"

const useQuery = () => new URLSearchParams(useLocation().search)

const NominationList = () => {
  document.title = "Nomination List"

  const query = useQuery()
  const awardId = query.get("id")

  const history = useNavigate()
  const dispatch = useDispatch()
  const [openRowId, setOpenRowId] = useState(null)

  const toggleInvoiceMenu = id => {
    setOpenRowId(prev => (prev === id ? null : id))
  }

  const nominationList = useSelector(state => state.awards.nominationList)
  const resendInvoiceScreen = useSelector(
    state => state.screens.pvs.resendInvoice
  )
  const downloadInvoicesScreen = useSelector(
    state => state.screens.pvs.downloadInvoices
  )

  useEffect(() => {
    dispatch(getNominationList({ enc_award_id: awardId, page: 1, limit: 10 }))
    dispatch(getAwardsCategoryList({ enc_award_id: awardId }))
  }, [])

  useEffect(() => {
    if (resendInvoiceScreen.success) {
      toast.success(resendInvoiceScreen.message)
      dispatch({ type: RESEND_INVOICE_RESET })
    }
    if (resendInvoiceScreen.error) {
      toast.error(resendInvoiceScreen.error)
      dispatch({ type: RESEND_INVOICE_RESET })
    }
  }, [resendInvoiceScreen])

  const resendInvoice = registrationId => {
    dispatch(
      resendInvoiceAction({ enc_bazaar_register_id: registrationId }, token)
    )
  }

  const downloadInvoice = () => {
    dispatch(downloadInvoices({ enc_bazaar_id: bazaarId }, token))
  }

  const [menu, setMenu] = useState(false)
  const toggleMenu = () => {
    setMenu(!menu)
  }

  const [tooltipOpen, setTooltipOpen] = useState(false)

  const toggleTooltip = () => setTooltipOpen(!tooltipOpen)

  const columns = useMemo(
    () => [
      {
        header: "Nominee Name",
        accessorKey: "full_name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Business Name",
        accessorKey: "business_name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Company Type",
        accessorKey: "company_type_label",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Business Nature",
        accessorKey: "business_nature_label",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        // header: "Status",
        header: () => (
          <div>
            Status{" "}
            <i
              className="mdi mdi-information-outline"
              id="statusTooltip"
              style={{ cursor: "pointer" }}
            />
            {/* <Tooltip
              placement="top"
              isOpen={tooltipOpen}
              target="statusTooltip"
              toggle={toggleTooltip}
            >
              This shows the current status of the nomination
            </Tooltip> */}
          </div>
        ),
        accessorKey: "status_label",
        enableColumnFilter: false,
        enableSorting: true,
        cell: info => {
          const status = info.getValue()
          return (
            <span
              className={`badge ${
                status === "Winners"
                  ? "bg-success"
                  : status === "Interested" || status === "Nominees"
                  ? "bg-warning"
                  : status === "Shortlisted"
                  ? "bg-info"
                  : "bg-danger"
              }`}
            >
              {status}
            </span>
          )
        },
      },
      {
        header: "Action",
        enableSorting: false,
        cell: info => {
          const row = info.row.original
          const rowId = row.enc_award_nomination_id

          return (
            <div
              className="d-flex align-items-center gap-2"
              onClick={e => e.stopPropagation()}
            >
              <button
                className="btn btn-sm btn-primary"
                onClick={() =>
                  history(`/awards/nomination-details?id=${rowId}`)
                }
              >
                View Nomination
              </button>

              <ActionDropdown>
                <button
                  className="dropdown-item"
                  onClick={() => {
                    // Update Invoice logic
                  }}
                >
                  Update Invoice
                </button>

                <button
                  className="dropdown-item"
                  onClick={() => {
                    // Regenerate Invoice logic
                  }}
                >
                  Regenerate Invoice
                </button>
              </ActionDropdown>
            </div>
          )
        },
      },
      // {
      //   header: "Action",
      //   accessorKey: "action",
      //   enableColumnFilter: false,
      //   enableSorting: false,
      //   cell: info => {
      //     const row = info.row.original
      //     const isPaid = row.payment_status?.toLowerCase() === "paid"
      //     const [invoiceMenu, setInvoiceMenu] = useState(false)
      //     const toggleInvoiceMenu = () => {
      //       setInvoiceMenu(!invoiceMenu)
      //     }

      //     return (
      //       <div className="d-flex align-items-center" style={{ gap: "8px" }}>
      //         <button
      //           className="btn btn-sm btn-primary"
      //           onClick={() =>
      //             history(
      //               `/awards/nomination-details?id=${row.enc_award_nomination_id}`
      //             )
      //           }
      //           title="View Nomination"
      //         >
      //           View Nomination
      //         </button>

      //         <Dropdown
      //           className="dropwodn-invoice"
      //           isOpen={invoiceMenu}
      //           toggle={toggleInvoiceMenu}
      //         >
      //           <DropdownToggle
      //             color="primary"
      //             className="btn btn-sm btn-primary"
      //           >
      //             Invoice &nbsp;
      //             <i className="mdi mdi-dots-vertical" />
      //           </DropdownToggle>
      //           <DropdownMenu end>
      //             <DropdownItem tag="a" href="#">
      //               Update Invoice
      //             </DropdownItem>
      //             <DropdownItem tag="a" href="#">
      //               Regenerate Invoice
      //             </DropdownItem>
      //           </DropdownMenu>
      //         </Dropdown>
      //       </div>
      //     )
      //   },
      // },
    ],
    [NominationList, openRowId]
  )

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="d-flex justify-content-end my-4">
          <Dropdown isOpen={menu} toggle={toggleMenu}>
            <DropdownToggle
              color="primary"
              className="btn btn-primary dropdown-toggle waves-effect waves-light"
            >
              Download &nbsp;<i className="mdi mdi-download-circle"></i>
            </DropdownToggle>
            <DropdownMenu end>
              <DropdownItem tag="a" href="#">
                Nomination invoices
              </DropdownItem>
              <DropdownItem tag="a" href="#">
                Nominee pictures
              </DropdownItem>

              <DropdownItem divider />
              <DropdownItem tag="a" href="#">
                Winner invoices
              </DropdownItem>
              <DropdownItem tag="a" href="#">
                Winner pictures
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
          {/* <RefreshButton onRefresh={handleRefresh} /> */}
        </div>

        <TableContainer
          defaultPageSize={20}
          columns={columns}
          data={nominationList || []}
          isGlobalFilter={true}
          isPagination={true}
          isCustomPageSize={true}
          SearchPlaceholder="Search records..."
          pagination="pagination"
          isAddButton={false}
          paginationWrapper="dataTables_paginate paging_simple_numbers"
          tableClass="table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          theadClass="table-light"
          divClassName="table-responsive mb-4 nominee-tbl-wrapper"
        />
        <Tooltip
          placement="top"
          isOpen={tooltipOpen}
          autohide={false}
          target="statusTooltip"
          toggle={toggleTooltip}
          style={{ maxWidth: "400px", textAlign: "left" }}
        >
          <strong>Interested: </strong>
          <span>Filled nomination form but not paid</span>
          <br />

          <strong>Nominees: </strong>
          <span>After paying nomination fee</span>
          <br />

          <strong>Shortlisted: </strong>
          <span>When admin approves nominee for next step</span>
          <br />

          <strong>Winners: </strong>
          <span>After paying participation fee</span>
          <br />

          <strong>Rejected: </strong>
          <span>When admin rejects nominee</span>
          <br />

          {/* {` ()
          Nominees (After paying nomination fee)
          Shortlisted (When admin approves nominee for next step)
          Winners (After paying participation fee)
          Rejected (When admin rejects nominee)`} */}
        </Tooltip>
      </div>
    </div>
  )
}

export default NominationList
